/* eslint-disable eqeqeq */
import React, { useEffect, useState, useCallback } from "react";
import Form from "react-bootstrap/Form";
import CustomBtn from "../fragments/CustomBtn";
import DiscountTag from "../fragments/DiscountTag";
import ticket_expired from "img/ticket_expired.png";
import { useSelector, useDispatch } from "react-redux";
import { getBranchTags } from "../../redux/handlers/payment.handler";

const DISCOUNT_TYPES = {
  END_BILL: "endBill",
};

export default function PayDiscount({
  payment,
  money,
  actions,
  order,
  ui,
  discount,
  settings,
  ...props
}) {
  const { details: orderDetails } = order;
  const {
    list: discounts,
    add: addDiscount,
    remove: removeDiscount,
    getByType,
  } = discount;
  const { paymentSettings } = settings;

  const [discountType, setDiscountType] = useState(1);

  const discountBasePrice =
    orderDetails?.total_before_discount || orderDetails?.paymentNet;

  return (
    <div className="h-full flex flex-col">
      <div className="flex gap-[min(2.01vw,20.63px)] mt-[min(2.44vw,25px)] mb-4">
        <CustomBtn
          onClick={() => setDiscountType(1)}
          className={`leading-[0.8] w-fit min-w-[min(9.96vw,102px)] text-14 font-[500] min-h-[min(3.32vw,34px)] rounded-[min(0.39vw,4px)] ${
            discountType == 1
              ? "btn-main-active text-white"
              : "btn-white text-[#6D788D] border border-[rgba(109,120,141,0.5)]"
          }`}
          btntxt="ส่วนลด"
        />
        <CustomBtn
          disabled={true}
          onClick={() => setDiscountType(2)}
          className={`leading-[0.8] w-fit min-w-[min(9.96vw,102px)] text-14 font-[500] min-h-[min(3.32vw,34px)] rounded-[min(0.39vw,4px)] ${
            discountType == 2
              ? "btn-main-active text-white "
              : "btn-white text-[#6D788D] border border-[rgba(109,120,141,0.5)] opacity-50"
          }`}
          btntxt="คูปอง"
        />
      </div>

      {discountType == 1 ? (
        <BillDiscount
          orderPrice={orderDetails?.paymentNet}
          discountBasePrice={discountBasePrice}
          couponList={paymentSettings}
          discountObj={{
            discounts,
            getDiscountByType: getByType,
            addDiscount,
            removeDiscount,
          }}
          payment={payment}
        />
      ) : (
        <div className="flex-1 flex items-center justify-center">
          <div className="text-center">
            <img src={ticket_expired} className="mx-auto" alt="คูปองหมดอายุ" />
            <div className="text-center mt-3">ระบบคูปองถูกปิดการใช้งาน</div>
          </div>
        </div>
      )}
    </div>
  );
}

const BillDiscount = ({
  orderPrice,
  discountBasePrice,
  couponList,
  discountObj,
  payment,
}) => {
  const dispatch = useDispatch();
  const branchId = localStorage.getItem("branchId");
  const businessSlug = localStorage.getItem("businessSlug");
  const [tagList, setTagList] = useState([]);
  const [apiTagList, setApiTagList] = useState([]);
  const [loading, setLoading] = useState(false);
  const billData = useSelector((state) => state.bill.data);
  const [roundingType, setRoundingType] = useState(null);

  const calculationBasePrice = discountBasePrice || orderPrice;

  const endBillDiscount = discountObj.getDiscountByType
    ? discountObj.getDiscountByType(DISCOUNT_TYPES.END_BILL)
    : null;

  const [selectedTagId, setSelectedTagId] = useState(
    endBillDiscount?.id || null
  );

  const [discount, setDiscount] = useState({
    id: endBillDiscount?.id || null,
    name: endBillDiscount?.name || null,
    discountTypeId: endBillDiscount?.discountTypeId || 1,
    value: endBillDiscount?.value || 0,
    isPercent: endBillDiscount?.isPercent || false,
    amount: endBillDiscount?.amount || 0,
    discountType: DISCOUNT_TYPES.END_BILL,
  });

  const roundValue = useCallback(
    (value) => {
      if (!value) return 0;

      if (!roundingType) {
        return Math.floor(value * 100) / 100;
      }

      switch (roundingType) {
        case "ceil":
          return Math.ceil(value);
        case "floor":
          return Math.floor(value);
        case "round":
          return Math.round(value);
        default:
          return Math.floor(value * 100) / 100;
      }
    },
    [roundingType]
  );

  useEffect(() => {
    const fetchBranchTags = async () => {
      if (!businessSlug || !branchId) return;
      setLoading(true);
      try {
        const response = await dispatch(getBranchTags(businessSlug, branchId));
        if (response) {
          const transformedTags = response.map((tag) => ({
            id: tag.id,
            name: tag.name,
            value: parseFloat(tag.discount_value),
            discountTypeId: tag.discount_type === "percent" ? 2 : 1,
            discount_type: tag.discount_type,
            created_at: tag.created_at,
            updated_at: tag.updated_at,
          }));
          setApiTagList(transformedTags);
        }
      } catch (error) {
        console.error("Error fetching branch tags:", error);
        setApiTagList([]);
      } finally {
        setLoading(false);
      }
    };

    fetchBranchTags();
  }, [businessSlug, branchId, dispatch]);

  useEffect(() => {
    if (billData) {
      if (billData.rounding_type) {
        setRoundingType(billData.rounding_type);
      } else {
        setRoundingType(null);
      }
    }
  }, [billData]);

  useEffect(() => {
    setTagList(couponList?.coupons || []);
  }, [couponList]);

  const handleDiscountTypeChange = (newType) => {
    setSelectedTagId(null);
    setDiscount((prev) => ({
      ...prev,
      id: null,
      name: null,
      discountTypeId: newType,
      isPercent: newType === 2,
      amount: 0,
      value: 0,
    }));
  };

  const handleDiscountInputChange = (e) => {
    const value = e.target.value;

    const decimal = value.split(".");
    if (decimal.length > 1 && decimal[1].length > 2) {
      return;
    }

    const numberValue = Number(value);

    if (discount.discountTypeId == 1) {
      const existTag = [...tagList, ...apiTagList].find(
        (tag) => tag.discountTypeId == 1 && tag.value == numberValue
      );

      if (existTag) {
        setSelectedTagId(existTag.id);
        setDiscount((prev) => ({
          ...prev,
          id: existTag.id,
          name: existTag.name,
          amount: numberValue,
        }));
      } else {
        setSelectedTagId(null);

        if (numberValue > calculationBasePrice) {
          const adjustedValue =
            Math.floor(parseFloat(calculationBasePrice) * 100) / 100;
          setDiscount((prev) => ({
            ...prev,
            id: null,
            name: null,
            amount: adjustedValue,
          }));
        } else {
          setDiscount((prev) => ({
            ...prev,
            id: null,
            name: null,
            amount: numberValue,
          }));
        }
      }
    } else if (discount.discountTypeId == 2) {
      const existTag = [...tagList, ...apiTagList].find(
        (tag) => tag.discountTypeId == 2 && tag.value == numberValue
      );

      if (existTag) {
        setSelectedTagId(existTag.id);
        setDiscount((prev) => ({
          ...prev,
          id: existTag.id,
          name: existTag.name,
          amount: numberValue,
        }));
      } else {
        setSelectedTagId(null);

        if (numberValue > 100) {
          setDiscount((prev) => ({
            ...prev,
            id: null,
            name: null,
            amount: 100,
          }));
        } else {
          setDiscount((prev) => ({
            ...prev,
            id: null,
            name: null,
            amount: numberValue,
          }));
        }
      }
    }
  };

  const handleConfirmDiscount = async () => {
    if (!discount.amount || discount.amount <= 0) return;

    let newDiscount = 0;
    if (discount.discountTypeId == 1) {
      newDiscount = discount.amount;
    } else if (discount.discountTypeId == 2 || discount.isPercent) {
      newDiscount = calculationBasePrice * (discount.amount / 100);
      newDiscount = Math.floor(newDiscount * 100) / 100;
    }

    const newDiscountRound = roundValue(newDiscount);

    if (payment && payment.setData) {
      payment.setData([]);
    }
    if (payment && payment.setSelectedMethod) {
      payment.setSelectedMethod({ paymentChannelID: 0 });
    }

    const updatedDiscount = {
      ...discount,
      payment_method_id: payment.selectedMethod.paymentChannelID,
      discountType: DISCOUNT_TYPES.END_BILL,
      value: newDiscount,
      valueRound: newDiscountRound,
      rounding_type: roundingType,
      discountName:
        discount.name ||
        `ส่วนลด ${discount.discountTypeId === 1 ? "บาท" : "%"}`,
    };

    if (discountObj.addDiscount) {
      discountObj.addDiscount(updatedDiscount);
    }

    payment.setSelectedMethod({ paymentChannelID: 0 });
  };

  const isConfirmDisabled =
    !payment.setSelectedMethod || !discount.amount || discount.amount <= 0;

  return (
    <>
      <div className="mt-[min(2.25vw,23px)] text-18">เลือกส่วนลด</div>

      <div className="w-full mt-[min(2.44vw,25px)] border-b-[0.5px] border-[rgba(182,187,198,0.3)] min-h-[166px] max-h-[166px] overflow-y-auto flex gap-x-[min(1.07vw,11px)] gap-y-[min(1.46vw,15px)] flex-wrap pb-[min(3.32vw,34px)]">
        {loading ? (
          <div className="w-full flex items-center justify-center">
            <div>กำลังโหลด...</div>
          </div>
        ) : (
          <>
            {apiTagList.map((tag) => (
              <DiscountTag
                key={`api-tag-${tag.id}`}
                isActive={selectedTagId === tag.id}
                handleOnClick={() => {
                  setSelectedTagId(tag.id);
                  setDiscount((prev) => ({
                    ...prev,
                    id: tag.id,
                    name: tag.name,
                    discountTypeId: tag.discountTypeId,
                    isPercent: tag.discountTypeId === 2,
                    amount: tag.value,
                    value:
                      tag.discountTypeId === 2
                        ? (tag.value / 100) * calculationBasePrice
                        : tag.value,
                  }));
                }}
                data={{
                  name: tag.name,
                  value: tag.value,
                  discountTypeId: tag.discountTypeId,
                }}
              />
            ))}
          </>
        )}
      </div>

      <div className="mt-[min(2.93vw,30px)] max-w-[min(30.96vw,317px)]">
        <div className="mb-2">
          <div className="mb-3 flex justify-between">
            <div className="inline-block">
              <div className="text-16 flex items-center">
                <img
                  className="object-contain aspect-[20/19] mr-[min(0.59vw,6px)] min-w-[min(1.95vw,20px)] h-fit"
                  src="/img/icons/icon-discount-orange.svg"
                  alt="ไอคอนส่วนลด"
                />
                <div>ส่วนลด</div>
              </div>
            </div>
            <div>
              <Form.Check
                inline
                label="บาท"
                name="discount_baht"
                type="radio"
                id="discount-1"
                className="form-check-st-5 tc-7 me-3"
                value={1}
                onChange={() => {
                  if (discount.discountTypeId === 2) {
                    handleDiscountTypeChange(1);
                  }
                }}
                checked={discount.discountTypeId == 1}
              />
              <Form.Check
                inline
                label="เปอร์เซ็นต์(%)"
                name="discount_percent"
                type="radio"
                id="discount-2"
                className="form-check-st-5 tc-7 me-0"
                value={2}
                onChange={() => {
                  if (discount.discountTypeId === 1) {
                    handleDiscountTypeChange(2);
                  }
                }}
                checked={discount.discountTypeId == 2}
              />
            </div>
          </div>
          <div>
            <input
              className="form-control text-end border-0 fs-20 pe-4 form-st-5"
              type="number"
              onClick={(e) => {
                e.target.select();
              }}
              style={{
                background: "#FFF",
                borderRadius: "8px",
                filter: "drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.14))",
              }}
              onChange={handleDiscountInputChange}
              value={discount.amount || ""}
              placeholder="0.00"
            />
          </div>
        </div>
      </div>

      <div className="ml-auto mt-auto">
        <CustomBtn
          onClick={handleConfirmDiscount}
          className="leading-[0.8] w-fit min-w-[min(12.66vw,129.6px)] text-18 text-white font-[700] min-h-[min(5.47vw,56px)] rounded-[min(0.39vw,4px)] btn-main-active"
          btntxt="ยืนยันส่วนลด"
          disabled={isConfirmDisabled}
        />
      </div>
    </>
  );
};
